import styled from 'styled-components';

export const ErrorCardContainer = styled.div`
  margin: 50px auto;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 400px;
  background-color: #ffffff;
  width: 1200px;

  .serverErrorImg {
    width: 196px;
    height: 196px;
    margin-bottom: 26px;
  }
  .pageNotFoundImg {
    width: 142px;
    height: 166px;
    margin-bottom: 40px;
  }

  .noInternetImg {
    width: 232px;
    height: 200px;
    margin-bottom: 24px;
  }

  .width328 {
    width: 328px;
  }
  .makeFlex {
    display: flex;
  }
  .dirColumn {
    flex-direction: column;
  }
  .perfectCenter {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .textCenter {
    text-align: center;
  }
  .latoBlack {
    font-weight: 900;
  }

  .lineHeight24 {
    line-height: 24px !important;
  }
  .lineHeight20 {
    line-height: 20px !important;
  }
  .font20 {
    font-size: 20px;
  }
  .font14 {
    font-size: 14px;
  }
  .secondaryTxt {
    color: #4a4a4a;
  }
  .appendTop8 {
    margin-top: 8px;
  }
`;
